"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("isomorphic-fetch");
function extractIp(rawText) {
    return rawText.replace(/\s+/g, '');
}
function v4() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, text, ip;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch('https://ipv4.icanhazip.com/')];
                case 1:
                    request = _a.sent();
                    return [4 /*yield*/, request.text()];
                case 2:
                    text = _a.sent();
                    ip = extractIp(text);
                    return [2 /*return*/, ip];
            }
        });
    });
}
exports.v4 = v4;
function v6() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, text, ip;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch('https://ipv6.icanhazip.com')];
                case 1:
                    request = _a.sent();
                    return [4 /*yield*/, request.text()];
                case 2:
                    text = _a.sent();
                    ip = extractIp(text);
                    return [2 /*return*/, ip];
            }
        });
    });
}
exports.v6 = v6;
//# sourceMappingURL=ip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/what-is-my-ip-address/dist/ip.js
// module id = 1994
// module chunks = 0